<template>
    <div class="card shadow p-0">
        <div class="card-header bg-transparent">
            <div>
                 <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> 
                   
                <h3 class="mb-0">
                    {{ $tc('message.allergies', 1) }}
                </h3>
            </div>
        </div>
        <div class="">
            <div class="p-1em">
<!--                        <h3 class="card-title text-center mb-0">-->
<!--                            {{$tc('message.medicalFiles',1)}} :{{dossier}} - {{nom}}-->
<!--                        </h3>-->
                <b-container>
                    <div class="list-group list-group-flush">
                        <b-row>
                            <b-col col sm="12" class="pb-3">
                                <div class="list-group-item">
                                    {{ $t('message.description') }}:

                                    <div class="font-weight-bold">
                                        {{ mAllergy.description }}
                                    </div>
                                </div>
                            </b-col>
<!--                                    <b-col col sm="12">-->
<!--                                        <div class="list-group-item">-->
<!--                                            {{ $t('message.startDate') }}:-->

<!--                                            <div class="font-weight-bold">-->
<!--                                                {{ mAllergy.date }}-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </b-col>-->
                        </b-row>
                        <b-row v-if="mAllergy.isAuthor || hasMedecinControleRole || hasAdminRole || hasAssistante">
                            <b-col cols="6">
                                <b-button variant="primary" @click="updateAllergy">
                                    {{ $t('message.edit') }}
                                </b-button>
                            </b-col>
                            <b-col cols="6">
                                <b-button v-b-modal.delete-modal variant="danger">
                                    {{ $t('message.delete') }}
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>
                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.allergies', 1)"
                            hide-footer>
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mAllergy.description }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteAllergy">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>

                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "Allergy",

        computed: {
            ...mapGetters(["allergy",
                'hasAdminRole',
                'hasMedecinControleRole',
                'hasAssistante',
                'hasPraticienRole',
            ]),
            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },
            mAllergy: function() {
                return this.allergy;
            },
            dossier:function () {
                if ( typeof  this.mAllergy.dossier == 'object')
                    return   this.mAllergy.dossier.numero_dossier;
                return "";
            },
            nom:function(){
                if ( typeof  this.mAllergy.user == 'object'){
                   let user = this.mAllergy.user;
                return  user.prenom ? user.prenom+' ' : '' + user.nom ? user.nom :'';
                }
                return "";
            }
        },

        data() {
            return {
                allergy_id: this.$route.params.allergy
            }
        },

        methods: {
            getAllergy() {
                let args = {
                    allergy: this.allergy_id
                };

                this.$store.dispatch("getAllergy", { args });
            },

            updateAllergy() {
                this.$router.push({ name: 'edit-allergy', params: { allergy: this.allergy_id } });
            },

            deleteAllergy() {
                let self = this;
                let args = {
                    allergy: this.allergy_id
                };

                let successMessage = this.$i18n.t('message.allergyDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteAllergy', { args, index: self.allergy_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();
                });

            }
        },

        mounted() {
            this.getAllergy();
        }
    }
</script>

<style scoped>

</style>